// Unit mismatch warning helpers.
// All thresholds operate on DISPLAY values (what the user types into the input).

/**
 * Check if a length value looks like the wrong unit.
 * @param {string|number} displayValue - The value the user typed (in current display unit)
 * @param {boolean} isMetric - true = mm mode, false = inches mode
 * @returns {string|null} Warning message or null
 */
export function lengthUnitWarning(displayValue, isMetric) {
  const num = parseFloat(displayValue);
  if (!num || num <= 0) return null;

  if (isMetric) {
    // mm mode: if value < 12 mm, they're probably typing inches
    if (num < 12) {
      return 'This value seems small for mm. Are you entering inches? Check the length unit switch.';
    }
  } else {
    // inches mode: if value > 10 in, they're probably typing mm
    if (num > 10) {
      return 'This value seems large for inches. Are you entering mm? Check the length unit switch.';
    }
  }
  return null;
}

/**
 * Check if a weight value looks like the wrong unit.
 * @param {string|number} displayValue - The value the user typed (in current display unit)
 * @param {boolean} isMetricWeight - true = grams mode, false = oz mode
 * @returns {string|null} Warning message or null
 */
export function weightUnitWarning(displayValue, isMetricWeight) {
  const num = parseFloat(displayValue);
  if (!num || num <= 0) return null;

  if (isMetricWeight) {
    // grams mode: if value < 7 g, they're probably typing oz
    if (num < 7) {
      return 'This value seems small for grams. Are you entering oz? Check the weight unit switch.';
    }
  } else {
    // oz mode: if value > 4 oz, they're probably typing grams
    if (num > 4) {
      return 'This value seems large for oz. Are you entering grams? Check the weight unit switch.';
    }
  }
  return null;
}
